// Admin
import AdminAllStore from "@/Stores/Admin/AdminAllStore";
import FileManagerStore from "@/Stores/Admin/FileManagerStore";
// Site
// import AddSnackbarsStore from "@/Stores/All/AddSnackbarsStore";
// import AuthorizationStore from "@/Stores/All/AuthorizationStore";
import BasketStoreMobx from "@/Stores/Pages/BasketStoreMobx";
// import BlogStore from "@/Stores/Pages/BlogStore";
// import BuyOneClickStoreMobx from "@/Stores/All/BuyOneClickStoreMobx";
import CatalogStore from "@/Stores/Site/CatalogStore";
import CollectionsStore from "@/Stores/Site/CollectionsStore";
import CountryStore from "@/Stores/Header/CountryStore";
import FavouritesStore from "@/Stores/Pages/FavouritesStore";
import GiftCertificateStore from "@/Stores/Pages/GiftCertificateStore";
import MapsStore from "@/Stores/All/MapsStore";
import MobileMenuStore from "@/Stores/Header/MobileMenuStore";
import ModalStoreMobx from "@/Stores/Site/ModalStoreMobx";
import NewsStore from "@/Stores/Pages/NewsStore";
// import ProductDetailStore from "@/Stores/Pages/ProductDetailStore";
import ProfileStore from "@/Stores/Pages/ProfileStore";
// import QuickViewStore from "@/Stores/All/QuickViewStore";
// import SelectCityStore from "@/Stores/Header/SelectCityStore";
// import SearchStoreMobx from "@/Stores/Site/SearchStoreMobx";
// import SoulStore from "@/Stores/Pages/SoulStore";
import SubMenuStore from "@/Stores/Header/SubMenuStore";

class RootStores {
    constructor() {
        /**
         * Admin
         */
        this.adminAllStore = new AdminAllStore(this);
        this.fileManagerStore = new FileManagerStore(this);

        /**
         * Site
         */
        this.catalogStore = new CatalogStore(this);
        this.collectionsStore = new CollectionsStore(this);
        // this.searchStore = new SearchStoreMobx(this);

        /**
         * All
         */
        if (typeof localStorage !== 'undefined') {
            this.storage = localStorage;
        } else {
            this.storage = {};
        }

        // this.addSnackbarsStore = new AddSnackbarsStore(this);
        this.modalStore = new ModalStoreMobx(this);
        // this.quickViewStore = new QuickViewStore(this);
        // this.buyOneClickStore = new BuyOneClickStoreMobx(this);
        // this.authorizationStore = new AuthorizationStore(this);
        this.mapsStore = new MapsStore(this);

        /**
         * Header
         */
        this.subMenuStore = new SubMenuStore(this);
        this.mobileMenuStore = new MobileMenuStore(this);
        this.countryStore = new CountryStore(this);
        // this.selectCityStore = new SelectCityStore(this);

        /**
         * Pages
         */
        this.basketStore = new BasketStoreMobx(this);
        // this.blogStore = new BlogStore(this);
        this.favouritesStore = new FavouritesStore(this);
        this.giftCertificateStore = new GiftCertificateStore(this);
        this.newsStore = new NewsStore(this);
        // this.productDetailStore = new ProductDetailStore(this);
        this.profileStore = new ProfileStore(this);
        // this.soulStore = new SoulStore(this);
    }
}

export default new RootStores();
